import { render, staticRenderFns } from "./SpaceSuccessPage.vue?vue&type=template&id=4b9ad6d2&scoped=true"
import script from "./SpaceSuccessPage.vue?vue&type=script&lang=ts"
export * from "./SpaceSuccessPage.vue?vue&type=script&lang=ts"
import style0 from "./SpaceSuccessPage.vue?vue&type=style&index=0&id=4b9ad6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ad6d2",
  null
  
)

export default component.exports